import sortedBy from 'util/sortedBy';

import {AnalyticsParameterConfigGraphQL as AnalyticsParameterConfig} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';

export default function sortParameterConfigs(
  parameterConfigs: Array<AnalyticsParameterConfig>
): Array<AnalyticsParameterConfig> {
  return sortedBy(parameterConfigs, [{accessor: 'systemName', naturalSort: true}]);
}
